(() => {
  const root = window.Shopify?.routes?.root || '/';
  const strings = window.ftrStrings || {};
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency || window.Shopify?.currency?.active || window.ftrCurrency || 'USD'}).format(value / 100);
  const closeDialog = dialog => {if(dialog?.open) dialog.close();};
  const openDialog = dialog => {if(dialog && !dialog.open) dialog.showModal();};
  const selectMedia = (section, id) => {
    if(!section || !id || !section.querySelector(`[data-ftr-media="${CSS.escape(String(id))}"]`)) return;
    section.querySelectorAll('[data-ftr-media]').forEach(slide => {const active = slide.dataset.ftrMedia === String(id);slide.hidden = !active;slide.classList.toggle('is-active',active);if(!active) slide.querySelectorAll('video').forEach(video => video.pause());});
    section.querySelectorAll('[data-ftr-media-target]').forEach(button => button.classList.toggle('is-active',button.dataset.ftrMediaTarget === String(id)));
  };
  const renderCart = async () => {
    const dialog = document.getElementById('FTRCart');
    if(!dialog) return;
    const response = await fetch(root + 'cart.js',{headers:{Accept:'application/json'}});
    if(!response.ok) throw new Error(strings.error);
    const cart = await response.json();
    document.querySelectorAll('[data-ftr-cart-count]').forEach(node => node.textContent = cart.item_count);
    dialog.querySelector('[data-ftr-cart-empty]').hidden = cart.item_count > 0;
    dialog.querySelector('[data-ftr-cart-bottom]').hidden = cart.item_count === 0;
    const container = dialog.querySelector('[data-ftr-cart-lines]');
    container.replaceChildren();
    cart.items.forEach(item => {
      const fragment = document.getElementById('FTRCartLine').content.cloneNode(true);
      const row = fragment.querySelector('article');
      row.dataset.cartKey = item.key;
      fragment.querySelector('[data-cart-image-link]').href = item.url;
      const img = fragment.querySelector('[data-cart-image]');
      if(item.image){img.src = item.image;img.alt = item.product_title;}else{img.hidden = true;}
      const title = fragment.querySelector('[data-cart-title]');title.href = item.url;title.textContent = item.product_title;
      const opts = (item.options_with_values || []).filter(o => o.value !== 'Default Title');
      fragment.querySelector('[data-cart-variant]').textContent = opts.length > 1 ? opts.map(o => `${o.name}: ${o.value}`).join('\n') : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
      fragment.querySelector('[data-cart-price]').textContent = money(item.final_line_price,cart.currency);
      fragment.querySelector('[data-cart-quantity]').value = item.quantity;
      container.append(fragment);
    });
    dialog.querySelector('[data-ftr-cart-total]').textContent = money(cart.total_price,cart.currency);
  };
  const openCart = async () => {
    const dialog = document.getElementById('FTRCart');if(!dialog) return;
    openDialog(dialog);
    const error = dialog.querySelector('[data-ftr-cart-error]');error.textContent = '';
    dialog.setAttribute('aria-busy','true');
    try{await renderCart();}catch(e){error.textContent = e.message || strings.error;}finally{dialog.removeAttribute('aria-busy');}
  };
  const updateCart = async (row,quantity) => {
    const dialog = row.closest('dialog');const error = dialog.querySelector('[data-ftr-cart-error]');error.textContent = '';
    row.querySelectorAll('input,button').forEach(node => node.disabled = true);
    try{
      const response = await fetch(root + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:row.dataset.cartKey,quantity})});
      const data = await response.json();if(!response.ok) throw new Error(data.description || data.message || strings.error);
      await renderCart();
    }catch(e){error.textContent = e.message || strings.error;row.querySelectorAll('input,button').forEach(node => node.disabled = false);}
  };
  let variantController;
  const updateVariant = async input => {
    const section = input.closest('[data-ftr-product]');
    const box = section.querySelector('[data-ftr-buybox]');
    const focusedId = input.id;
    const chosen = [...section.querySelectorAll('[data-ftr-option-id]:checked')].map(node => node.dataset.ftrOptionId);
    const url = new URL(window.location.href);url.searchParams.delete('variant');url.searchParams.set('option_values',chosen.join(','));url.searchParams.set('section_id',section.dataset.sectionId);
    variantController?.abort();variantController = new AbortController();
    const wasDisabled = box.querySelector('[data-ftr-add]').disabled;
    box.setAttribute('aria-busy','true');box.querySelector('[data-ftr-add]').disabled = true;
    const quantity = box.querySelector('[name="quantity"]').value;
    try{
      const response = await fetch(url.toString(),{signal:variantController.signal});if(!response.ok) throw new Error(strings.error);
      const html = await response.text();const parsed = new DOMParser().parseFromString(html,'text/html');
      const fresh = parsed.querySelector('[data-ftr-product]');const newBox = fresh?.querySelector('[data-ftr-buybox]');if(!newBox) throw new Error(strings.error);
      const swap = () => box.replaceWith(newBox);
      if(document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) await document.startViewTransition(swap).updateCallbackDone;else swap();
      const qty = newBox.querySelector('[name="quantity"]');if(qty) qty.value = Math.max(Number(qty.min || 1),Math.min(Number(qty.max || 999),Number(quantity)));
      selectMedia(section,fresh.dataset.selectedMedia);
      const variant = newBox.querySelector('[data-ftr-variant-id]').value;
      url.searchParams.delete('section_id');url.searchParams.delete('option_values');url.searchParams.set('variant',variant);history.replaceState({},'',url);
      newBox.querySelector('#'+CSS.escape(focusedId))?.focus({preventScroll:true});
      initSticky(section);
    }catch(e){if(e.name !== 'AbortError'){box.querySelector('[data-ftr-product-error]').textContent = e.message || strings.error;box.querySelector('[data-ftr-add]').disabled = wasDisabled;}}
    finally{box.removeAttribute('aria-busy');}
  };
  const initSticky = section => {
    const sticky = section.querySelector('.ftr-product__sticky');const button = section.querySelector('[data-ftr-add]');
    if(!sticky || !button) return;
    section._ftrObserver?.disconnect();
    section._ftrObserver = new IntersectionObserver(entries => {sticky.classList.toggle('is-visible',!entries[0].isIntersecting && button.getBoundingClientRect().top < 0);},{threshold:0});
    section._ftrObserver.observe(button);
  };
  const init = () => {
    document.querySelectorAll('[data-ftr-product]').forEach(section => {selectMedia(section,section.dataset.selectedMedia);initSticky(section);});
    if(matchMedia('(prefers-reduced-motion: reduce)').matches) document.querySelectorAll('.ftr video[autoplay]').forEach(video => {video.pause();video.removeAttribute('autoplay');});
  };
  document.addEventListener('click',event => {
    const target = event.target instanceof Element ? event.target : null;if(!target) return;
    const close = target.closest('[data-ftr-close]');if(close) closeDialog(close.closest('dialog'));
    const open = target.closest('[data-ftr-open]');if(open){event.preventDefault();openDialog(document.getElementById(open.dataset.ftrOpen));}
    if(target.closest('[data-ftr-cart-open]')){event.preventDefault();openCart();}
    const media = target.closest('[data-ftr-media-target]');if(media) selectMedia(media.closest('[data-ftr-product]'),media.dataset.ftrMediaTarget);
    const sticky = target.closest('[data-ftr-sticky-add]');if(sticky) sticky.closest('[data-ftr-product]').querySelector('[data-ftr-product-form]').requestSubmit();
    const remove = target.closest('[data-cart-remove]');if(remove) updateCart(remove.closest('[data-cart-key]'),0);
    if(target.matches('dialog[data-ftr-dialog]')){const r = target.getBoundingClientRect();if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(target);}
  });
  document.addEventListener('change',event => {
    const target = event.target;
    if(target.matches('[data-ftr-option-id]')) updateVariant(target);
    if(target.matches('[data-ftr-sort]')) target.form.requestSubmit();
    if(target.matches('[data-cart-quantity]')){const n = Number(target.value);if(Number.isInteger(n) && n >= 0) updateCart(target.closest('[data-cart-key]'),n);}
  });
  document.addEventListener('submit',async event => {
    const form = event.target;if(!form.matches('[data-ftr-product-form]')) return;
    event.preventDefault();const button = form.querySelector('[data-ftr-add]');if(button.disabled) return;
    const content = button.innerHTML;const error = form.querySelector('[data-ftr-product-error]');error.textContent = '';button.disabled = true;button.textContent = strings.adding || '…';
    try{
      const response = await fetch(root + 'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const data = await response.json();if(!response.ok) throw new Error(data.description || data.message || strings.error);
      await openCart();
    }catch(e){error.textContent = e.message || strings.error;}finally{button.innerHTML = content;button.disabled = false;}
  });
  document.addEventListener('shopify:section:load',init);
  init();
})();
